import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { teams } from 'redux/modules'
import { getSignupURL } from 'utils/localstorage'
import { withRouter } from 'react-router-dom'
import { compose } from 'redux'
import Loader from './Loader'

const TeamsLoader = ({
  history,
  children,
  fetchTeamsByParams,
  additionalParams,
  ...restProps
}) => {
  const fetchMethod = () => fetchTeamsByParams(additionalParams)

  return (
    <Loader
      fetchMethod={() => {
        return fetchMethod().then((res) => {
          if (res.response.length === 0) {
            history.push(getSignupURL())
          }
        })
      }}
      {...restProps}
    >
      {children}
    </Loader>
  )
}

TeamsLoader.defaultProps = {
  additionalParams: {},
}
TeamsLoader.propTypes = {
  history: PropTypes.shape().isRequired,
  children: PropTypes.node.isRequired,
  fetchTeamsByParams: PropTypes.func.isRequired,
  additionalParams: PropTypes.shape(),
}

export default compose(
  withRouter,
  connect(null, {
    fetchTeamsByParams: teams.fetchTeamsByParams,
  })
)(TeamsLoader)
